<div [class]="mixedMode() ? 'unified-tile-body h-full' : ''">
    <div class="grid grid-cols-12 gap-3 lg:gap-4 grid-flow-row-dense items-stretch ">
        @if (showSection(SectionId.STATS)) {
        <div class="group relative border border-slate-200 dark:border-slate-700 p-4 bg-white/90 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl"
            [ngClass]="getSectionColClass(SectionId.STATS)" [style.order]="sectionOrder(SectionId.STATS)">
            @if (!mixedMode() && canPinToCustomDashboard(SectionId.STATS)) {
            <button type="button" (click)="addToCustomDashboard(SectionId.STATS); $event.stopPropagation()"
                [disabled]="isAddingToCustomDashboard(SectionId.STATS)"
                class="group/pin absolute cursor-pointer top-2 right-2 z-30 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                [ngClass]="isAddedToCustomDashboard(SectionId.STATS)
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
        : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                [attr.aria-label]="isAddedToCustomDashboard(SectionId.STATS) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                [title]="isAddedToCustomDashboard(SectionId.STATS) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                @if (isAddingToCustomDashboard(SectionId.STATS)) {
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <span>{{ isAddedToCustomDashboard(SectionId.STATS) ? 'Removing' : 'Adding' }}&hellip;</span>
                } @else if (isAddedToCustomDashboard(SectionId.STATS)) {
                <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                    from Custom Dashboard</span>
                } @else {
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                    to Custom Dashboard</span>
                }
            </button>
            }

            @if (isRecoveryStatusLoading() || isSuccessRateTrendLoading() || isLoadingCreationTrend() ||
            isPreviousDataLoading()) {
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-2 mb-3">
                @for (i of [1,2,3,4,5]; track i) {
                <div
                    class="bg-white dark:bg-surface-2 p-3 rounded-xl border border-slate-200 dark:border-gray-700 shadow-sm animate-pulse h-[106px] flex flex-col justify-between">
                    <div class="h-4 w-28 bg-slate-100 dark:bg-slate-700/50 rounded shadow-sm"></div>
                    <div class="flex items-center gap-2">
                        <div class="h-8 w-24 bg-slate-100 dark:bg-slate-700/60 rounded-lg shadow-sm"></div>
                        <div class="h-5 w-14 bg-slate-100 dark:bg-slate-700/40 rounded-full shadow-sm"></div>
                    </div>
                    <div class="h-3 w-32 bg-slate-50 dark:bg-slate-900/30 rounded shadow-sm mb-1"></div>
                </div>
                }
            </div>
            } @else {
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-2 mb-3">
                @for (card of metricCards(); track card.title) {
                <div
                    class="bg-white dark:bg-surface-2 p-3 rounded-xl border border-slate-200 dark:border-gray-700 shadow-sm">
                    <h3 class="text-sm text-slate-500 dark:text-slate-400 font-medium mb-2">{{ card.title }}</h3>
                    <div class="flex items-center gap-2 mb-1">
                        <div class="2xl:text-2xl text-xl font-semibold text-slate-900 dark:text-white">
                            @if (card.type === 'currency') {
                            {{ (card.value || 0) | currency }}
                            } @else if (card.type === 'percent') {
                            {{ (card.value || 0) | percent:'1.2-2' }}
                            } @else {
                            {{ (card.value || 0) | number }}
                            }
                        </div>
                        @if (card.trend) {
                        <span class="text-xs font-medium px-2 py-0.5 rounded-full flex items-center gap-1"
                            [ngClass]="card.trend.colorClass">
                            @if (card.trend.icon) {
                            <app-icon-v2 [name]="card.trend.icon" size="12"></app-icon-v2>
                            } @else {
                            {{ card.trend.direction === 'up' ? '↗' : '↘' }}
                            }
                            {{ card.trend.value}}
                        </span>
                        }
                    </div>
                    <p class="text-xs" [ngClass]="card.footerClass || 'text-slate-400 dark:text-slate-500'">{{
                        card.footer }}</p>
                </div>
                }
            </div>
            }
        </div>
        }

        @if (showSection(SectionId.RECOVERY_AMOUNT)) {
        <div class="group relative  border border-slate-200 dark:border-slate-700 p-4 bg-white/90 dark:bg-surface-1/60 backdrop-blur-sm rounded-xl"
            [ngClass]="getSectionColClass(SectionId.RECOVERY_AMOUNT)"
            [style.order]="sectionOrder(SectionId.RECOVERY_AMOUNT)">
            @if (!mixedMode() && canPinToCustomDashboard(SectionId.RECOVERY_AMOUNT)) {
            <button type="button" (click)="addToCustomDashboard(SectionId.RECOVERY_AMOUNT); $event.stopPropagation()"
                [disabled]="isAddingToCustomDashboard(SectionId.RECOVERY_AMOUNT)"
                class="group/pin absolute cursor-pointer top-2 right-2 z-30 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                [ngClass]="isAddedToCustomDashboard(SectionId.RECOVERY_AMOUNT)
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
        : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                [attr.aria-label]="isAddedToCustomDashboard(SectionId.RECOVERY_AMOUNT) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                [title]="isAddedToCustomDashboard(SectionId.RECOVERY_AMOUNT) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                @if (isAddingToCustomDashboard(SectionId.RECOVERY_AMOUNT)) {
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <span>{{ isAddedToCustomDashboard(SectionId.RECOVERY_AMOUNT) ? 'Removing' : 'Adding' }}&hellip;</span>
                } @else if (isAddedToCustomDashboard(SectionId.RECOVERY_AMOUNT)) {
                <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                    from Custom Dashboard</span>
                } @else {
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                    to Custom Dashboard</span>
                }
            </button>
            }

            @if (isLoadingCreationTrend() || isSuccessRateTrendLoading() || isRecoveryRateLoading()) {
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                @for (i of [1, 2, 3]; track i) {
                <div
                    class="bg-white dark:bg-surface-2 p-4 rounded-xl border border-slate-200 dark:border-gray-700 shadow-sm animate-pulse h-[158px]">
                </div>
                }
            </div>
            } @else {
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                @for (insight of insightCards(); track insight.title) {
                <div [class]="insight.bgColor + ' p-4 rounded-xl border ' + insight.borderColor + ' h-full'">
                    <div class="flex justify-between items-start mb-4">
                        <div class="flex items-center gap-2">
                            <div [class]="'flex p-2 ' + insight.iconBg + ' rounded-lg shadow-sm'">
                                <app-icon-v2 [name]="insight.icon" [size]="20"
                                    class="text-slate-700 dark:text-slate-200"></app-icon-v2>
                            </div>
                            <h3 class="font-semibold text-slate-800 dark:text-white">{{ insight.title }}</h3>
                        </div>
                        <span
                            [class]="'inline-flex items-center gap-1 px-2 py-1 rounded-full ' + insight.trendBg + ' ' + insight.trendColor + ' text-xs font-medium shadow-sm'">
                            <app-icon-v2 [name]="insight.trendIcon" [size]="12"></app-icon-v2>
                            {{ insight.trendLabel }}
                        </span>
                    </div>
                    <div class="flex items-center gap-3 mb-2">
                        <span class="text-lg text-slate-500 dark:text-slate-400">{{ insight.fromValue }}</span>
                        <app-icon-v2 name="arrowRight" [size]="16" class="text-slate-400"></app-icon-v2>
                        <span class="text-xl font-bold text-slate-900 dark:text-white">{{ insight.toValue }}</span>
                    </div>
                    <p class="text-sm text-slate-600 dark:text-slate-400 leading-snug">{{ insight.insightText }}</p>
                </div>
                }
            </div>
            }
        </div>
        }

        @if (showSection(SectionId.CRITICAL_INSIGHTS)) {
        <div class="group relative" [ngClass]="getSectionColClass(SectionId.CRITICAL_INSIGHTS)"
            [style.order]="sectionOrder(SectionId.CRITICAL_INSIGHTS)">
            @if (!mixedMode() && canPinToCustomDashboard(SectionId.CRITICAL_INSIGHTS)) {
            <button type="button" (click)="addToCustomDashboard(SectionId.CRITICAL_INSIGHTS); $event.stopPropagation()"
                [disabled]="isAddingToCustomDashboard(SectionId.CRITICAL_INSIGHTS)"
                class="group/pin absolute cursor-pointer top-2 right-2 z-30 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                [ngClass]="isAddedToCustomDashboard(SectionId.CRITICAL_INSIGHTS)
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
        : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                [attr.aria-label]="isAddedToCustomDashboard(SectionId.CRITICAL_INSIGHTS) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                [title]="isAddedToCustomDashboard(SectionId.CRITICAL_INSIGHTS) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                @if (isAddingToCustomDashboard(SectionId.CRITICAL_INSIGHTS)) {
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <span>{{ isAddedToCustomDashboard(SectionId.CRITICAL_INSIGHTS) ? 'Removing' : 'Adding' }}&hellip;</span>
                } @else if (isAddedToCustomDashboard(SectionId.CRITICAL_INSIGHTS)) {
                <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                    from Custom Dashboard</span>
                } @else {
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                    to Custom Dashboard</span>
                }
            </button>
            }

            @if (isRecoveryStatusLoading() || isSuccessRateTrendLoading() || isLoadingCreationTrend() ||
            isRecoveryRateLoading() || isPaymentOutcomesLoading() || isDuplicatesLoading() || isProcessingTimeLoading()
            || isPreviousDataLoading())
            {
            <div
                class="bg-white dark:bg-surface-2 p-4 rounded-2xl border border-slate-200 dark:border-gray-700 shadow-sm mb-3 animate-pulse">
                <div class="flex items-center gap-2 mb-4">
                    <div
                        class="w-5 h-5 rounded-full border-2 border-slate-200 dark:border-gray-700 flex items-center justify-center">
                        <div class="w-1 h-2 bg-slate-200 dark:bg-slate-700 rounded-full"></div>
                    </div>
                    <div class="h-6 w-72 bg-slate-100 dark:bg-slate-700/50 rounded shadow-sm"></div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    @for (i of [1,2,3,4]; track i) {
                    <div
                        class="bg-slate-50 dark:bg-surface-0/50 py-4 px-5 rounded-xl border border-slate-100 dark:border-gray-700/50 h-[100px] flex flex-col justify-center">
                        <div class="h-5 w-40 bg-slate-200/80 dark:bg-slate-700/80 rounded shadow-sm mb-3"></div>
                        <div class="space-y-2">
                            <div class="h-3 w-full bg-slate-200/50 dark:bg-slate-700/50 rounded shadow-sm"></div>
                            <div class="h-3 w-4/5 bg-slate-200/50 dark:bg-slate-700/50 rounded shadow-sm"></div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            } @else if (criticalInsights().length > 0) {
            <div
                class="bg-white dark:bg-surface-2 p-3 rounded-2xl border border-slate-200 dark:border-gray-700 shadow-sm mb-3">
                <div class="flex items-center gap-2 mb-3">
                    <div
                        class="w-5 h-5 rounded-full border-2 border-orange-400 flex items-center justify-center text-orange-400">
                        <span class="text-[10px] font-bold leading-none">!</span>
                    </div>
                    <h3 class="font-bold text-slate-800 dark:text-slate-100 text-lg">Critical Insights & Opportunities
                    </h3>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    @for (insight of criticalInsights(); track insight.title) {
                    <div
                        class="bg-slate-50 dark:bg-surface-0/50 py-3 px-5 rounded-xl border border-slate-100 dark:border-gray-700/50 flex flex-col h-full hover:border-slate-300 dark:hover:border-slate-600 transition-all duration-200 cursor-default">
                        <h4 class="font-bold text-slate-800 dark:text-slate-100 mb-2">{{ insight.title }}</h4>
                        <p class="text-sm text-slate-500 dark:text-slate-400 leading-relaxed font-normal">
                            {{ insight.description }}
                        </p>
                    </div>
                    }
                </div>
            </div>
            } @else if (mixedMode()) {
            <div
                class="bg-white dark:bg-surface-2 p-6 rounded-2xl border border-slate-200 dark:border-gray-700 shadow-sm flex flex-col items-center justify-center min-h-[150px] text-center mb-3">
                <app-icon-v2 name="sparkles" [size]="40" class="text-slate-300 dark:text-slate-600 mb-3"></app-icon-v2>
                <h3 class="font-bold text-slate-700 dark:text-slate-200">No Critical Insights</h3>
                <p class="text-sm text-slate-500 mt-1">There are currently no critical insights or opportunities for
                    this period.</p>
            </div>
            }
        </div>
        }

        @for (col of orderedVisibleCharts(); track col.sectionId) {
        <div [ngClass]="getSectionColClass(col.sectionId)" [style.order]="sectionOrder(col.sectionId)"
            class="group bg-white dark:bg-surface-2 p-4 rounded-xl border border-slate-200 dark:border-gray-700 shadow-sm flex flex-col h-full relative"
            [class.p-6]="col.type === 'lollipop' || col.type === 'polar' || col.type === 'isometric' || col.type === 'stacked-bar'">
            @if (!mixedMode() && canPinToCustomDashboard(col.sectionId)) {
            <button type="button" (click)="addToCustomDashboard(col.sectionId); $event.stopPropagation()"
                [disabled]="isAddingToCustomDashboard(col.sectionId)"
                class="group/pin absolute cursor-pointer top-2 right-2 z-30 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                [ngClass]="isAddedToCustomDashboard(col.sectionId)
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
        : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                [attr.aria-label]="isAddedToCustomDashboard(col.sectionId) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                [title]="isAddedToCustomDashboard(col.sectionId) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                @if (isAddingToCustomDashboard(col.sectionId)) {
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <span>{{ isAddedToCustomDashboard(col.sectionId) ? 'Removing' : 'Adding' }}&hellip;</span>
                } @else if (isAddedToCustomDashboard(col.sectionId)) {
                <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                    from Custom Dashboard</span>
                } @else {
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                    to Custom Dashboard</span>
                }
            </button>
            }

            @if (col.loading) {
            <app-individual-toaster [message]="'Loading ' + col.title.toLowerCase() + '...'" [position]="'top-center'"
                [type]="'info'" [loaderType]="'dark'" [fontSize]="'24px'"></app-individual-toaster>
            }

            <div class="mb-4">
                <h3 class="font-semibold text-slate-800 dark:text-white"
                    [class.font-bold]="col.type === 'lollipop' || col.type === 'polar'">{{ col.title }}</h3>
                @if (col.subtitle) {
                <p class="text-sm text-slate-500 dark:text-slate-400" [class.mb-0]="col.type === 'isometric'"
                    [class.mb-4]="col.type === 'stacked-bar'">{{ col.subtitle }}</p>
                }
            </div>

            <div class="flex-grow w-full relative flex items-center justify-center min-h-[200px]"
                [class.h-[250px]]="col.type === 'bar-line'" [id]="col.type === 'pie' ? 'pieChartContainer' : ''">

                @if (col.hasData !== false) {
                @switch (col.type) {
                @case ('bar-line') {
                <div class="w-full h-full" [class.overflow-x-auto]="duration() > 730">
                    <app-bar-line [class]="duration() > 730 ? 'w-full h-full block' : 'w-full h-full'"
                        [style.min-width.px]="duration() > 730 ? ($any(col.data)?.length * 50) : null"
                        [data1]="$any(col.data)" [valueKey]="$any(col.config).valueKey"
                        [labelKey]="$any(col.config).labelKey" [addGradient]="true" [showBackground]="false"
                        [barTextposition]="'none'" [valueType]="'$'"
                        [margin]="{ top: 0, right: 35, bottom: 50, left: 50 }" [lines]="$any(col.config).lines"
                        [rightAxisLabel]="''" [hideRightAxis]="false" [rightAxisType]="'number'" [minBarWidth]="20"
                        [maxBarWidth]="40" [barTextColor]="'#64748b'" [legendGap]="$any(col.config).legendGap"
                        [legendData]="$any(col.config).legendData" [tooltipData]="$any(col.config).tooltipData">
                    </app-bar-line>
                </div>
                }
                @case ('pie') {
                <div class="w-full flex justify-center items-center pl-2 sm:pl-6 lg:pl-10 pt-2 pb-2">
                    <style>
                        ::ng-deep #pieChartContainer svg {
                            overflow: visible !important;
                        }

                        ::ng-deep #pieChartContainer .pie-labels {
                            transform: scale(0.85) !important;
                            transform-origin: 0 0;
                        }
                    </style>
                    <app-pie-chart [data]="$any(col.data)" [type]="$any(col.config).type" [showLegend]="true"
                        [addGradient]="true" [legendPosition]="'right'" [width]="170" [height]="230"
                        [preferInputDimensions]="true" [centerValue]="$any(col.config).centerValue"
                        [centerLabel]="$any(col.config).centerLabel" [isDonut]="$any(col.config).isDonut">
                    </app-pie-chart>
                </div>
                }
                @case ('isometric') {
                <app-isometric-bar [data]="$any(col.data)" [width]="$any(col.config).width"
                    [height]="$any(col.config).height">
                </app-isometric-bar>
                }
                @case ('multi-horizontal-bar') {
                <app-multi-horizontal-bar-chart [data]="$any(col.data)" [showLegend]="$any(col.config).showLegend"
                    [leftMargin]="$any(col.config).leftMargin" [barSpacing]="$any(col.config).barSpacing || 6"
                    [height]="$any(col.config).height || 0" [showTooltip]="$any(col.config).showTooltip !== false">
                </app-multi-horizontal-bar-chart>
                }
                @case ('comprehensive-bar') {
                <app-comprehensive-bar-chart [series]="$any(col.data)" [mode]="'multiple'" [orientation]="'vertical'"
                    [height]="$any(col.config).height" [barRadius]="$any(col.config).barRadius || 4"
                    [barWidth]="$any(col.config).barWidth || 0.8" [barGap]="$any(col.config).barGap ?? 0.1"
                    [showCard]="false" [cardPadding]="'0'" [groupGap]="$any(col.config).groupGap || 0.2"
                    [xAxis]="$any(col.config).xAxis || { show: true, showGrid: false, showAxisLine: $any(col.config).showXAxisLine }"
                    [yAxis]="{ show: true, showGrid: $any(col.config).showYAxisGrid, showAxisLine: false, gridStyle: 'dashed' }"
                    [tooltip]="{ show: true, showHoverLine: true, valueFormat: 'currency' }">
                </app-comprehensive-bar-chart>
                }
                @case ('stacked-bar') {
                <app-stacked-bar [data]="$any(col.data)" [width]="$any(col.config).width"
                    [showYAxis]="$any(col.config).showYAxis" [showXAxis]="$any(col.config).showXAxis"
                    [legendMarginTop]="$any(col.config).legendMarginTop" [height]="$any(col.config).height">
                </app-stacked-bar>
                }
                @case ('line') {
                <div class="h-[300px] w-full flex-grow relative">
                    <app-line-chart [data1]="$any(col.data).overall" [data2]="$any(col.data).recurring"
                        [data3]="$any(col.data).partial" [valueKey]="'value'" [unit]="$any(col.config).unit"
                        [valueFormat]="'percent'" [showXAxis]="true" [showYAxis]="false" [showYAxisGrid]="false"
                        [showXAxisGrid]="false" [curveType]="'curveMonotoneX'"
                        [primaryLineColor]="$any(col.config).primaryLineColor"
                        [secondaryLineColor]="$any(col.config).secondaryLineColor"
                        [tertiaryLineColor]="$any(col.config).tertiaryLineColor" [dashedSeries]="[1,2]"
                        class="w-full h-full block" [marginProps]="{ top: 20, right: 20, bottom: 30, left: 10 }">
                    </app-line-chart>
                </div>
                }
                @case ('data-progress') {
                <div class="w-full">
                    <app-data-progress-bar [data]="$any(col.data)" [mode]="$any(col.config).mode"
                        [heightClass]="$any(col.config).heightClass" [trackColor]="$any(col.config).trackColor">
                    </app-data-progress-bar>
                </div>
                }
                @case ('lollipop') {
                <div class="h-[300px] w-full mb-6">
                    <app-lollipop-chart [data]="$any(col.data)" [margin]="$any(col.config).margin"
                        [scaleType]="$any(col.config).scaleType || 'arithmetic'">
                    </app-lollipop-chart>
                </div>
                }
                @case ('polar') {
                <div class="flex flex-col md:flex-row items-center gap-6 flex-grow mb-6">
                    <div class="h-[250px] w-full md:w-1/2 ">
                        <app-polar-area-chart [data]="$any(col.data)"
                            [valueType]="$any(col.config)?.valueType || 'number'"
                            [scaleType]="$any(col.config)?.scaleType || 'linear'">
                        </app-polar-area-chart>
                    </div>
                    <div class="w-full md:w-1/2 flex flex-col justify-center space-y-4">
                        @for (item of $any(col.data); track item.label) {
                        <div class="flex items-center gap-3">
                            <span class="w-2.5 h-2.5 rounded-full" [style.backgroundColor]="item.color"></span>
                            <span class="font-medium text-slate-700 dark:text-slate-300">{{ item.label }}</span>
                        </div>
                        }
                    </div>
                </div>
                }
                }
                } @else {
                <div
                    class="absolute inset-0 flex flex-col items-center justify-center text-slate-400 dark:text-slate-500">
                    <app-icon-v2 name="database" [size]="48" class="mb-3 opacity-50"></app-icon-v2>
                    <p class="text-sm font-medium">No data available</p>
                    <p class="text-xs mt-1">There are no records for this period.</p>
                </div>
                }
            </div>

            @if (col.hasData !== false && col.footerType === 'success-legend') {
            <div class="mt-4 flex flex-wrap items-center justify-center gap-6">
                @for (item of successRateLegend(); track item.label) {
                <div class="flex items-center gap-2">
                    <span [class]="'w-2 h-2 rounded-full ' + item.color"></span>
                    <span class="text-xs font-medium text-slate-600 dark:text-slate-300">{{ item.label }}</span>
                </div>
                }
            </div>
            }

            @if (col.hasData !== false && col.footerType === 'actions') {
            <div class="bg-slate-50 dark:bg-surface-0/30 rounded-lg p-4 text-sm mt-auto">
                <div class="flex items-center gap-2 mb-3 text-red-500 font-medium">
                    <app-icon-v2 name="check-circle" [size]="16"></app-icon-v2>
                    <span>Actions</span>
                </div>
                <ul class="space-y-3 text-slate-600 dark:text-slate-300">
                    @for (action of footerActions(); track action) {
                    <li class="flex items-start gap-2">
                        <span class="mt-1.5 w-1.5 h-1.5 rounded-full bg-slate-400"></span>
                        <span>{{ action }}</span>
                    </li>
                    }
                </ul>
            </div>
            }

            @if (col.hasData !== false && col.footerType === 'insights') {
            <div class="bg-slate-50 dark:bg-surface-0/30 rounded-lg p-4 text-sm mt-auto">
                <div class="flex items-center gap-2 mb-3 text-red-500 font-medium">
                    <app-icon-v2 name="check-circle" [size]="16"></app-icon-v2>
                    <span>Current Distribution (Insights)</span>
                </div>
                <ul class="space-y-3 text-slate-600 dark:text-slate-300">
                    @for (insight of footerInsights(); track insight.label) {
                    <li class="flex items-start gap-2">
                        <span class="mt-1.5 w-1.5 h-1.5 rounded-full bg-slate-400"></span>
                        <span><span class="font-medium">{{ insight.label }}</span> {{ insight.value }}</span>
                    </li>
                    }
                </ul>
            </div>
            }
        </div>
        }

        @if (showSection(SectionId.YOY_PERFORMANCE)) {
        <div class="group relative" [ngClass]="getSectionColClass(SectionId.YOY_PERFORMANCE)"
            [style.order]="sectionOrder(SectionId.YOY_PERFORMANCE)">
            @if (!mixedMode() && canPinToCustomDashboard(SectionId.YOY_PERFORMANCE)) {
            <button type="button" (click)="addToCustomDashboard(SectionId.YOY_PERFORMANCE); $event.stopPropagation()"
                [disabled]="isAddingToCustomDashboard(SectionId.YOY_PERFORMANCE)"
                class="group/pin absolute cursor-pointer top-2 right-2 z-30 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                [ngClass]="isAddedToCustomDashboard(SectionId.YOY_PERFORMANCE)
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
        : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                [attr.aria-label]="isAddedToCustomDashboard(SectionId.YOY_PERFORMANCE) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                [title]="isAddedToCustomDashboard(SectionId.YOY_PERFORMANCE) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                @if (isAddingToCustomDashboard(SectionId.YOY_PERFORMANCE)) {
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <span>{{ isAddedToCustomDashboard(SectionId.YOY_PERFORMANCE) ? 'Removing' : 'Adding' }}&hellip;</span>
                } @else if (isAddedToCustomDashboard(SectionId.YOY_PERFORMANCE)) {
                <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                    from Custom Dashboard</span>
                } @else {
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                    to Custom Dashboard</span>
                }
            </button>
            }

            <div
                class="bg-white dark:bg-surface-2 p-6 rounded-xl border border-slate-200 dark:border-gray-700 shadow-sm h-full">
                <div class="mb-6">
                    <h3 class="font-bold text-slate-800 dark:text-white">Year-Over-Year Performance</h3>
                    <p class="text-sm text-slate-500 dark:text-slate-400">Tracking progress and changes year over year
                    </p>
                </div>

                <div class="space-y-4">
                    @for (yearData of yearOverYearData; track yearData.year) {
                    <div
                        class="rounded-lg border border-slate-100 dark:border-gray-700 bg-slate-50 dark:bg-slate-700/20 overflow-hidden">
                        <!-- Header Row -->
                        <div class="p-4 flex flex-col md:flex-row items-center justify-between gap-4 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700/40 transition-colors"
                            (click)="toggleYear(yearData.year)">

                            <!-- Year & Toggle -->
                            <div class="flex items-center gap-4 w-full md:w-1/5">
                                <div class="flex flex-col">
                                    <span class="text-lg font-semibold text-slate-700 dark:text-slate-200">{{
                                        yearData.year }}</span>
                                    <div class="flex items-center gap-1 text-xs text-slate-500 dark:text-slate-400">
                                        <span>View Months</span>
                                        <app-icon-v2
                                            [name]="expandedYear === yearData.year ? 'chevronDown' : 'chevronRight'"
                                            [size]="12"></app-icon-v2>
                                    </div>
                                </div>
                            </div>

                            <!-- Metrics Grid -->
                            <div class="grid grid-cols-2 md:grid-cols-4 gap-4 w-full md:w-4/5">
                                @for (config of yoyMetricConfigs(); track config.label) {
                                <div class="flex flex-col">
                                    <span class="text-xs text-slate-500 dark:text-slate-400">{{ config.label }}</span>
                                    <span class="font-bold"
                                        [class]="config.type === 'trend' ? (yearData.trendDirection === 'up' ? 'text-emerald-500' : 'text-rose-500') : (config.colorClass || 'text-slate-800 dark:text-white')"
                                        [class.flex]="config.type === 'trend'"
                                        [class.items-center]="config.type === 'trend'"
                                        [class.gap-1]="config.type === 'trend'">
                                        @switch (config.type) {
                                        @case ('currency') {
                                        {{ $any(yearData)[config.key] | currency:'USD':'symbol':'1.0-0' }}
                                        }
                                        @case ('percent') {
                                        {{ $any(yearData)[config.key] | number:'1.2-2' }}%
                                        }
                                        @case ('trend') {
                                        <app-icon-v2 [name]="yearData.trendDirection === 'up' ? 'arrowUp' : 'arrowDown'"
                                            [size]="14"></app-icon-v2>
                                        {{ $any(yearData)[config.key] | number:'1.2-2' }}%
                                        }
                                        @default {
                                        {{ $any(yearData)[config.key] }}
                                        }
                                        }
                                    </span>
                                </div>
                                }
                            </div>

                            <div class="hidden md:flex justify-end w-[50px]">
                                <span class="text-sm font-medium text-blue-500 hover:text-blue-600">View</span>
                            </div>
                        </div>

                        <!-- Expanded Content (Monthly Data) -->
                        @if (expandedYear === yearData.year) {
                        <div class="bg-white dark:bg-surface-2 border-t border-slate-100 dark:border-gray-700">
                            @for (month of yearData.monthlyData; track month.month) {
                            <div
                                class="p-4 border-b border-slate-50 dark:border-gray-700/50 last:border-0 flex flex-col md:flex-row items-center justify-between gap-4 hover:bg-slate-50 dark:hover:bg-slate-700/20">
                                <div class="w-full md:w-1/5">
                                    <span class="text-sm font-medium text-slate-600 dark:text-slate-300">{{ month.month
                                        }}</span>
                                </div>

                                <div class="grid grid-cols-2 md:grid-cols-4 gap-4 w-full md:w-4/5 pl-0 md:pl-0">
                                    @for (config of yoyMetricConfigs(); track config.label) {
                                    <div [class]="'text-sm font-medium ' + (config.type === 'trend' ? (month.trendDirection === 'up' ? 'text-emerald-500' : 'text-rose-500') : (config.colorClass || 'text-slate-700 dark:text-slate-300'))"
                                        [class.flex]="config.type === 'trend'"
                                        [class.items-center]="config.type === 'trend'"
                                        [class.gap-1]="config.type === 'trend'">
                                        @switch (config.type) {
                                        @case ('currency') {
                                        {{ $any(month)[config.key] | currency:'USD':'symbol':'1.0-0' }}
                                        }
                                        @case ('percent') {
                                        {{ $any(month)[config.key] | number:'1.2-2' }}%
                                        }
                                        @case ('trend') {
                                        <app-icon-v2 [name]="month.trendDirection === 'up' ? 'arrowUp' : 'arrowDown'"
                                            [size]="14"></app-icon-v2>
                                        {{ $any(month)[config.key] | number:'1.2-2' }}%
                                        }
                                        @default {
                                        {{ $any(month)[config.key] }}
                                        }
                                        }
                                    </div>
                                    }
                                </div>

                                <div class="hidden md:flex justify-end w-[50px]">
                                    <app-icon-v2 name="arrowRight" [size]="16" class="text-slate-300"></app-icon-v2>
                                </div>
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
        }

    </div>
</div>

<app-dashboard-layout-editor [open]="isLayoutEditorOpen()" [items]="editorItems()" [visibleCount]="editorVisibleCount()"
    (closed)="closeLayoutEditor()" (applied)="applyLayoutEditor()" (resetDefaults)="resetLayoutEditorToDefaults()"
    (cardDropped)="onEditorCardDrop($any($event))" (visibilityToggled)="toggleEditorCardVisibility($any($event))"
    (colSpanDecreased)="decreaseEditorCardColSpan($any($event))"
    (colSpanIncreased)="increaseEditorCardColSpan($any($event))" (autoAdjustWidth)="autoAdjustEditorWidths()" />